import axios, { isAxiosError } from 'axios';
import { Timecard } from '../types/Timecard';
import { Task } from '../types/Task';

const BASE_URL = process.env.REACT_APP_API_URL;

function throwApprovalsStatusError(err: unknown): never {
  if (isAxiosError(err) && err.response?.data) {
    const data = err.response.data as { error?: string; details?: string; code?: string };
    const parts = [data.error, data.details].filter(Boolean) as string[];
    const base = parts.length > 0 ? parts.join(' ') : err.message;
    const msg = data.code ? `${base} (${data.code})` : base;
    throw new Error(msg);
  }
  throw err instanceof Error ? err : new Error('Request failed');
}

export const approvalsService = {
  async getTimeCards(foremanAreaId?: number, serviceAreaId?: number): Promise<Timecard[]> {
    const params = new URLSearchParams();
    if (foremanAreaId != null) params.set('foremanAreaId', String(foremanAreaId));
    if (serviceAreaId != null) params.set('serviceAreaId', String(serviceAreaId));
    const query = params.toString();
    const url = query ? `${BASE_URL}/approvals?${query}` : `${BASE_URL}/approvals`;
    const response = await axios.get(url);
    return response.data;
  },

  async approveTimecard(timecardId: string): Promise<Timecard> {
    return this._updateTimeCardStatus(Number(timecardId), 'approved', 'Timecard approved');
  },

  async requestRevisions(timecardId: string, comments: string): Promise<Timecard> {
    try {
      const response = await axios.patch(`${BASE_URL}/approvals/${timecardId}/status`, {
        status: 'revisions_requested',
        statusComments: comments
      });
      return response.data;
    } catch (e) {
      throwApprovalsStatusError(e);
    }
  },

  async _updateTimeCardStatus(
    id: number, 
    status: 'approved' | 'revisions_requested',
    statusComments?: string
  ): Promise<Timecard> {
    try {
      const response = await axios.patch(`${BASE_URL}/approvals/${id}/status`, {
        status,
        statusComments
      });
      return response.data;
    } catch (e) {
      throwApprovalsStatusError(e);
    }
  },

  async updateTimecard(timecardId: string, data: Partial<Timecard>): Promise<Timecard> {
    const response = await axios.put(`${BASE_URL}/approvals/${timecardId}`, data);
    return response.data;
  },

  async getTasks(): Promise<Task[]> {
    const response = await axios.get(`${BASE_URL}/approvals/tasks`);
    return response.data;
  }
}; 